import React from 'react';
import { HorizontalFillBar } from 'components/Graphs/FillBars';
import { inPercent } from 'helpers/Utils.js';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import { ListContainer, ListBarContainer, ListTitle } from 'components/Pages/Reports/styled.js';
import ErrorEntityListCard from 'components/Pages/Reports/ErrorStates/ErrorEntityListCard.jsx';

const EntityListCard = ({ title, resources, unit = 'num_contents', formatter }) => {
  if (!resources.length) {
    return <ErrorEntityListCard title={title} />;
  }
  return (
    <ListContainer>
      <ListTitle>{title}</ListTitle>
      {resources.map((entity, idx) => (
        <ListBarContainer key={`${unit}-${entity.public_id}-${idx}`} value={entity[unit]}>
          <EntityItem data={entity} hideName />
          <HorizontalFillBar
            fillPct={inPercent(entity[`pct_${unit}`], 1, true)}
            label={<EntityItem data={entity} hideIcon />}
            value={formatter ? formatter(entity[unit]) : entity[unit]}
            stacked
            pctWidth="100%"
            labelWidth={'30%'}
          />
        </ListBarContainer>
      ))}
    </ListContainer>
  );
};

export default EntityListCard;
